$(function () {
	$('.js-activate-egocard').click(function () {
		$('.js-egocard-dialog').modal('show');
	});
	$('.js-egocard-submit-btn').click(function () {
		var errors = false;
		if (!$('#js-egocard-terms').is(':checked')) {
			errors = true;
			$('#js-egocard-terms').parent().find('b').addClass('red');
		}
		if (!$('#js-egocard-data').is(':checked')) {
			errors = true;
			$('#js-egocard-data').parent().find('b').addClass('red');
		}
		if (errors) {
			return;
		}
		$.post('/egocard/activate/'+$('.js-egocard-dialog').data('snr'), function (res) {
			if (res.status == 'ok') {
				window.location.reload();
			} else {
				ubian.utils.alert(ubian.translate('Egocard.Activate.Failed'), null, null, function () {
					$('.js-egocard-dialog').modal('hide');
				});
			}
		});
	});
    $('.js-display-egocard').click(function(){
        $.get('/egocard/'+$(this).data('snr')+'?popup=1', function (res){
            $('.js-egocard-detail-content').html(res.view);
            $('.js-egocard-detail-dialog').modal('show');
        });
    });
});